import * as ng from 'angular';

import { TimeSlot } from '../shared/time-slot.model';
import { UtilsService, defaultDateInputFormat } from '../../../shared';
import { GuestType } from '../../guest-type';
import { Event } from '../events-api.service';

export class TimeSlotEditorController implements ng.IController {
   static $inject = ['utils', 'dialogs'];

   constructor(private utils: UtilsService, private dialogs) { }

   timeslot:TimeSlot;
   guestTypes:GuestType[];
   event:Event

   resolve:{
      timeslot:TimeSlot,
      guestTypes:GuestType[],
      event:Event;
   };
   close:{({$value:any}):void};
   dismiss:{({$value:any}):void};

   get startDateTime() {
      if (this.timeslot.startDateTime) {
         let m = this.utils.toServerMoment(this.timeslot.startDateTime);
         return m.format(defaultDateInputFormat);
      }
   }

   set startDateTime(val:string) {
      this.timeslot.startDateTime = this.utils.toServerDateTime(val);
   }

   get endDateTime() {
      if (this.timeslot.endDateTime) {
         let m = this.utils.toServerMoment(this.timeslot.endDateTime);
         return m.format(defaultDateInputFormat);
      }
   }

   set endDateTime(val:string) {
      this.timeslot.endDateTime = this.utils.toServerDateTime(val);
   }

   get eventStartDateTime() {
      let m = this.utils.toServerMoment(this.event.startDateTime);
      return m.format(defaultDateInputFormat);
   }

   get eventEndDateTime() {
      let m = this.utils.toServerMoment(this.event.endDateTime);
      return m.format(defaultDateInputFormat);
   }

   $onInit() {
      this.event =  ng.copy(this.resolve.event);
      this.timeslot = ng.copy(this.resolve.timeslot);
      this.guestTypes = ng.copy(this.resolve.guestTypes);
   }

   cancel() {
      this.dismiss({$value: 'cancel'});
   }

   save(form:ng.IFormController) {
      form.$setSubmitted();
      if (form.$valid) {
         this.close({$value: this.timeslot});
      }
   }
}

ng.module('e360').component('timeSlotEditor', {
   templateUrl: require('./timeslot-editor.html'),
   controller: TimeSlotEditorController,
   bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
   }
});
